export default [
  {
    poll: "Roy Morgan Research",
    date: "23/10/2016",
    party: "National",
    median: "48"
  },
  {
    poll: "One News Colmar Brunton",
    date: "23/11/2016",
    party: "National",
    median: "50"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "National",
    median: "49.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "National",
    median: "45"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "National",
    median: "46"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/02/2017",
    party: "National",
    median: "48"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "National",
    median: "45"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "National",
    median: "43.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "National",
    median: "47.2"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "National",
    median: "46"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/04/2017",
    party: "National",
    median: "43"
  },
  {
    poll: "Roy Morgan Research",
    date: "14/05/2017",
    party: "National",
    median: "43"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "National",
    median: "49"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/06/2017",
    party: "National",
    median: "46.6"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "National",
    median: "47.4"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "National",
    median: "47"
  },
  {
    poll: "Roy Morgan Research",
    date: "09/07/2017",
    party: "National",
    median: "43"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "National",
    median: "47"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "National",
    median: "45.2"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "National",
    median: "44.4"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "National",
    median: "44"
  },
  {
    poll: "Roy Morgan Research",
    date: "23/10/2016",
    party: "Labour",
    median: "26.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "23/11/2016",
    party: "Labour",
    median: "28"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "Labour",
    median: "23"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "Labour",
    median: "28.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "Labour",
    median: "27"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/02/2017",
    party: "Labour",
    median: "26"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "Labour",
    median: "30"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "Labour",
    median: "29.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "Labour",
    median: "30.8"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "Labour",
    median: "30"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/04/2017",
    party: "Labour",
    median: "29.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "14/05/2017",
    party: "Labour",
    median: "28.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "Labour",
    median: "30"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/06/2017",
    party: "Labour",
    median: "25.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "Labour",
    median: "26.4"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "Labour",
    median: "27"
  },
  {
    poll: "Roy Morgan Research",
    date: "09/07/2017",
    party: "Labour",
    median: "30.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "Labour",
    median: "24"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "Labour",
    median: "24.1"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "Labour",
    median: "33.1"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "Labour",
    median: "37"
  },
  {
    poll: "Roy Morgan Research",
    date: "23/10/2016",
    party: "Green",
    median: "11.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "23/11/2016",
    party: "Green",
    median: "11"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "Green",
    median: "14.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "Green",
    median: "14.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "Green",
    median: "12.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/02/2017",
    party: "Green",
    median: "13"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "Green",
    median: "11"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "Green",
    median: "14.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "Green",
    median: "11.2"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "Green",
    median: "11"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/04/2017",
    party: "Green",
    median: "13"
  },
  {
    poll: "Roy Morgan Research",
    date: "14/05/2017",
    party: "Green",
    median: "14"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "Green",
    median: "9"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/06/2017",
    party: "Green",
    median: "14"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "Green",
    median: "12.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "Green",
    median: "11"
  },
  {
    poll: "Roy Morgan Research",
    date: "09/07/2017",
    party: "Green",
    median: "13.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "Green",
    median: "15"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "Green",
    median: "13"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "Green",
    median: "8.3"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "Green",
    median: "4.3"
  },
  {
    poll: "Roy Morgan Research",
    date: "23/10/2016",
    party: "New Zealand First",
    median: "10"
  },
  {
    poll: "One News Colmar Brunton",
    date: "23/11/2016",
    party: "New Zealand First",
    median: "10"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "New Zealand First",
    median: "8"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "New Zealand First",
    median: "7.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "New Zealand First",
    median: "9"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/02/2017",
    party: "New Zealand First",
    median: "8"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "New Zealand First",
    median: "11"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "New Zealand First",
    median: "7.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "New Zealand First",
    median: "7.6"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "New Zealand First",
    median: "8"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/04/2017",
    party: "New Zealand First",
    median: "10.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "14/05/2017",
    party: "New Zealand First",
    median: "10"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "New Zealand First",
    median: "9"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/06/2017",
    party: "New Zealand First",
    median: "9"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "New Zealand First",
    median: "9.4"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "New Zealand First",
    median: "11"
  },
  {
    poll: "Roy Morgan Research",
    date: "09/07/2017",
    party: "New Zealand First",
    median: "8"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "New Zealand First",
    median: "11"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "New Zealand First",
    median: "13"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "New Zealand First",
    median: "9.2"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "New Zealand First",
    median: "10"
  },
  {
    poll: "Roy Morgan Research",
    date: "23/10/2016",
    party: "Maori",
    median: "1.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "23/11/2016",
    party: "Maori",
    median: "1"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "Maori",
    median: "1.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "Maori",
    median: "1"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "Maori",
    median: "2"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/02/2017",
    party: "Maori",
    median: "2"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "Maori",
    median: "0.7"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "Maori",
    median: "2"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "Maori",
    median: "0.7"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "Maori",
    median: "4"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/04/2017",
    party: "Maori",
    median: "1"
  },
  {
    poll: "Roy Morgan Research",
    date: "14/05/2017",
    party: "Maori",
    median: "1.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "Maori",
    median: "0.6"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/06/2017",
    party: "Maori",
    median: "1.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "Maori",
    median: "0.7"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "Maori",
    median: "1.8"
  },
  {
    poll: "Roy Morgan Research",
    date: "09/07/2017",
    party: "Maori",
    median: "1.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "Maori",
    median: "0.6"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "Maori",
    median: "1.2"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "Maori",
    median: "1.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "Maori",
    median: "1.7"
  },
  {
    poll: "Roy Morgan Research",
    date: "23/10/2016",
    party: "ACT",
    median: "0.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "ACT",
    median: "1"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "ACT",
    median: "0.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "ACT",
    median: "0.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/02/2017",
    party: "ACT",
    median: "1"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "ACT",
    median: "0.8"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "ACT",
    median: "0.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "ACT",
    median: "0.4"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "ACT",
    median: "0.4"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/04/2017",
    party: "ACT",
    median: "1.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "14/05/2017",
    party: "ACT",
    median: "0.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "ACT",
    median: "0.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/06/2017",
    party: "ACT",
    median: "1"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "ACT",
    median: "0.9"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "ACT",
    median: "0.3"
  },
  {
    poll: "Roy Morgan Research",
    date: "09/07/2017",
    party: "ACT",
    median: "1"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "ACT",
    median: "0.3"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "ACT",
    median: "0.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "ACT",
    median: "0.6"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "ACT",
    median: "0.4"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "United Future",
    median: "0.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "United Future",
    median: "0.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "United Future",
    median: "0.3"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "United Future",
    median: "0.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "United Future",
    median: "0.4"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "United Future",
    median: "0.3"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "United Future",
    median: "0.2"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "United Future",
    median: "0.1"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "United Future",
    median: "0.2"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "United Future",
    median: "0.1"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "United Future",
    median: "0"
  },
  {
    poll: "One News Colmar Brunton",
    date: "23/11/2016",
    party: "Conservative",
    median: "0.2"
  },
  {
    poll: "Roy Morgan Research",
    date: "20/11/2016",
    party: "Conservative",
    median: "0.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "Conservative",
    median: "0.5"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/01/2017",
    party: "Conservative",
    median: "0.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "Conservative",
    median: "0.2"
  },
  {
    poll: "Roy Morgan Research",
    date: "12/03/2017",
    party: "Conservative",
    median: "0.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "Conservative",
    median: "0.4"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "Conservative",
    median: "0.3"
  },
  {
    poll: "Roy Morgan Research",
    date: "16/04/2017",
    party: "Conservative",
    median: "0.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "Conservative",
    median: "0.1"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "Conservative",
    median: "0.8"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "Conservative",
    median: "0.1"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "Conservative",
    median: "0.2"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "Conservative",
    median: "0.3"
  },
  {
    poll: "Roy Morgan Research",
    date: "11/12/2016",
    party: "Mana",
    median: "0.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "15/02/2017",
    party: "Mana",
    median: "0.8"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "Mana",
    median: "0.2"
  },
  {
    poll: "Roy Morgan Research",
    date: "14/05/2017",
    party: "Mana",
    median: "0.5"
  },
  ,
  {
    poll: "Roy Morgan Research",
    date: "11/06/2017",
    party: "Mana",
    median: "0.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "Mana",
    median: "0.3"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "Mana",
    median: "0.2"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "Mana",
    median: "0.3"
  },
  {
    poll: "Newshub Reid Research",
    date: "19/03/2017",
    party: "TOP",
    median: "0.8"
  },
  {
    poll: "One News Colmar Brunton",
    date: "22/03/2017",
    party: "TOP",
    median: "0.4"
  },
  {
    poll: "One News Colmar Brunton",
    date: "31/05/2017",
    party: "TOP",
    median: "1.4"
  },
  {
    poll: "Newshub Reid Research",
    date: "15/06/2017",
    party: "TOP",
    median: "0.8"
  },
  {
    poll: "One News Colmar Brunton",
    date: "05/07/2017",
    party: "TOP",
    median: "1.1"
  },
  {
    poll: "One News Colmar Brunton",
    date: "27/07/2017",
    party: "TOP",
    median: "1.5"
  },
  {
    poll: "Newshub Reid Research",
    date: "28/07/2017",
    party: "TOP",
    median: "2"
  },
  {
    poll: "Newshub Reid Research",
    date: "01/08/2017",
    party: "TOP",
    median: "2"
  },
  {
    poll: "One News Colmar Brunton",
    date: "16/08/2017",
    party: "TOP",
    median: "2.1"
  },
  { poll: "Roy Morgan", date: "13/08/2017", party: "National", median: "42.5" },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "National",
    median: "41"
  },
  { poll: "Roy Morgan", date: "13/08/2017", party: "Labour", median: "32.5" },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "Labour",
    median: "43"
  },
  { poll: "Roy Morgan", date: "13/08/2017", party: "Green", median: "9" },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "Green",
    median: "5"
  },
  {
    poll: "Roy Morgan",
    date: "13/08/2017",
    party: "New Zealand First",
    median: "11.5"
  },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "New Zealand First",
    median: "8"
  },
  { poll: "Roy Morgan", date: "13/08/2017", party: "Maori", median: "1.5" },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "Maori",
    median: "1"
  },
  { poll: "Roy Morgan", date: "13/08/2017", party: "ACT", median: "0.5" },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "ACT",
    median: "0"
  },
  {
    poll: "Roy Morgan",
    date: "13/08/2017",
    party: "United Future",
    median: "0"
  },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "United Future",
    median: "0"
  },
  {
    poll: "Roy Morgan",
    date: "13/08/2017",
    party: "Conservative",
    median: "0"
  },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "Conservative",
    median: "0"
  },
  { poll: "Roy Morgan", date: "13/08/2017", party: "Mana", median: "0" },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "Mana",
    median: "0"
  },
  { poll: "Roy Morgan", date: "13/08/2017", party: "TOP", median: "2" },
  {
    poll: "One News Colmar Brunton",
    date: "30/08/2017",
    party: "TOP",
    median: "1"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "National",
    median: "43.3"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "Labour",
    median: "39.4"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "Green",
    median: "6.1"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "New Zealand First",
    median: "6.6"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "Maori",
    median: "1"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "ACT",
    median: "0.06"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "United Future",
    median: "0.01"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "Conservative",
    median: "0.03"
  },
  {
    poll: "Newshub Reid Research",
    date: "30/08/2017",
    party: "TOP",
    median: "1.9"
  },
  {
    poll: "Colmar Brunton",
    date: "06/09/2017",
    party: "National",
    median: "39"
  },
  { poll: "Colmar Brunton", date: "06/09/2017", party: "Labour", median: "43" },
  { poll: "Colmar Brunton", date: "06/09/2017", party: "Green", median: "5" },
  {
    poll: "Colmar Brunton",
    date: "06/09/2017",
    party: "New Zealand First",
    median: "9"
  },
  { poll: "Colmar Brunton", date: "06/09/2017", party: "Maori", median: "2" },
  { poll: "Colmar Brunton", date: "06/09/2017", party: "ACT", median: "0.01" },
  { poll: "Colmar Brunton", date: "06/09/2017", party: "TOP", median: "1.9" },
  {
    poll: "Newshub Reid Research",
    date: "11/09/2017",
    party: "National",
    median: "47.3"
  },
  {
    poll: "Newshub Reid Research",
    date: "11/09/2017",
    party: "Labour",
    median: "37.8"
  },
  {
    poll: "Newshub Reid Research",
    date: "11/09/2017",
    party: "Green",
    median: "4.9"
  },
  {
    poll: "Newshub Reid Research",
    date: "11/09/2017",
    party: "New Zealand First",
    median: "6"
  },
  {
    poll: "Newshub Reid Research",
    date: "11/09/2017",
    party: "Maori",
    median: "1.1"
  },
  {
    poll: "Newshub Reid Research",
    date: "11/09/2017",
    party: "ACT",
    median: "0.06"
  },
  {
    poll: "Newshub Reid Research",
    date: "11/09/2017",
    party: "TOP",
    median: "1.6"
  },
  {
    poll: "Newshub Reid Research",
    date: "14/09/2017",
    party: "National",
    median: "40"
  },
  {
    poll: "Newshub Reid Research",
    date: "14/09/2017",
    party: "Labour",
    median: "44"
  },
  {
    poll: "Newshub Reid Research",
    date: "14/09/2017",
    party: "Green",
    median: "7"
  },
  {
    poll: "Newshub Reid Research",
    date: "14/09/2017",
    party: "New Zealand First",
    median: "6"
  },
  {
    poll: "Newshub Reid Research",
    date: "14/09/2017",
    party: "Maori",
    median: "1"
  },
  {
    poll: "Newshub Reid Research",
    date: "14/09/2017",
    party: "ACT",
    median: "0.06"
  },
  {
    poll: "Newshub Reid Research",
    date: "14/09/2017",
    party: "TOP",
    median: "2"
  }
];



// WEBPACK FOOTER //
// ./src/store/raw_polls_data.js